import clsx from "clsx";
import { CalcResult } from "../../components/CalcResult";

export function DeltaCalculation({
    calculation,
    highlightElements = false,
    section,
}: {
    calculation:
        | { title: string; formula: string[]; total: string }
        | null
        | undefined;
    highlightElements?: boolean;
    section: "previous" | "current" | "delta";
}) {
    if (!calculation) return null;

    return (
        <div>
            <h3 className="heading-m mb-3">{calculation.title}</h3>
            <span
                className={clsx(
                    "flex flex-wrap",
                    "formula-display items-center gap-y-2",
                )}
            >
                {calculation.formula.map((part, index) =>
                    !highlightElements ||
                    ["(", ")", "/", "-"].includes(part) ? (
                        <span
                            key={`${section}-${part}-${index}`}
                            className={clsx(
                                "py-0.5 pr-2",
                                part.includes("Missing") &&
                                    "ml-0 mr-2 rounded-lg border border-dashed border-gray-500 pl-2 text-gray-400",
                            )}
                        >
                            {part}
                        </span>
                    ) : (
                        <span
                            key={`${section}-${part}-${index}`}
                            className={clsx(
                                "text-default mr-2 px-2 py-0.5",
                                "border-default rounded-lg border",
                            )}
                            style={{ color: "white" }}
                        >
                            {part}
                        </span>
                    ),
                )}

                {calculation.formula.length > 1 && (
                    <CalcResult value={calculation.total} />
                )}
            </span>
        </div>
    );
}
